module.exports = __webpack_public_path__ + "static/media/btg_celular_03.d8214637.png";